exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".drag-handle{width:20px;margin-right:10px;padding-top:14px;cursor:grab}.ti-tag{background-color:#1aae7c!important;font-size:.75em!important}.vue-tags-input{width:100%;max-width:100%!important;border-color:#e9e9e9!important;padding:0!important;height:auto;min-height:calc(1.5em + .75rem + 2px)}.ti-input{border:none!important;padding:4px 7px}.quillWrapper .ql-editor{font-size:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cc63fe00","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"silenceDeprecations":["legacy-js-api","import","global-builtin","color-functions","slash-div"],"quietDeps":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Global/AdminForm.vue
// module id = 749
// module chunks = 0